import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const AppleIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-apple"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M39.843,11.4932 C37.658,10.6322 35.631,10.9752 34,11.9252 C32.369,10.9752 30.341,10.6322 28.157,11.4932 C25.605,12.4982 24,15.0542 24,17.7972 L24,24.2032 C24,26.9452 25.605,29.5012 28.157,30.5072 C30.341,31.3672 32.369,31.0242 34,30.0752 C35.631,31.0242 37.658,31.3672 39.843,30.5072 C42.395,29.5012 44,26.9452 44,24.2032 L44,17.7972 C44,15.0542 42.395,12.4982 39.843,11.4932"
          fill="#ffffff"
          className={styles.white}
        />
        <path
          d="M34,10.79 L33.9878531,10.7845061 C32.0756873,9.84416764 29.9273282,9.72037847 27.7902408,10.5628841 C24.8867188,11.7063165 23,14.6074495 23,17.7972 L23,24.2032 C23,27.3918903 24.8866509,30.2929189 27.7902651,31.4375255 L28.0817291,31.546309 C30.0201076,32.2301149 31.9582628,32.1256865 33.7121037,31.3447477 L34,31.209 L34.0125247,31.2158415 C35.9245277,32.1552296 38.0717359,32.2790264 40.2092452,31.4377184 C43.1133491,30.2929189 45,27.3918903 45,24.2032 L45,17.7972 C45,14.6074495 43.1132812,11.7063165 40.2094193,10.5627502 C38.1689263,9.75869316 36.1194178,9.83489458 34.274312,10.6613463 L34,10.79 Z M39.4763861,12.4235732 C41.5997378,13.2597677 43,15.4128956 43,17.7972 L43,24.2032 C43,26.5865645 41.5996435,28.7398374 39.4762651,29.5768745 C37.7299875,30.2641964 36.0245979,30.0962578 34.5029152,29.2108642 L34,28.9182422 L33.4970848,29.2108642 C31.9755097,30.0961952 30.2692239,30.2642007 28.5233904,29.5767388 C26.4003565,28.7398374 25,26.5865645 25,24.2032 L25,17.7972 C25,15.4128956 26.4002622,13.2597677 28.5234193,12.4236498 C30.2695051,11.7352892 31.9754993,11.903266 33.4966891,12.7893054 L34,13.0824663 L34.5033109,12.7893054 C36.0246083,11.9032033 37.7297063,11.7352934 39.4763861,12.4235732 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M27,23.5 C27.2761424,23.5 27.5,23.7238576 27.5,24 C27.5,25.3808576 29.6191424,27.5 31,27.5 C31.2761424,27.5 31.5,27.7238576 31.5,28 C31.5,28.2761424 31.2761424,28.5 31,28.5 C29.0668576,28.5 26.5,25.9331424 26.5,24 C26.5,23.7238576 26.7238576,23.5 27,23.5 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M27.5,22 C27.5,22.276 27.276,22.5 27,22.5 C26.724,22.5 26.5,22.276 26.5,22 C26.5,21.724 26.724,21.5 27,21.5 C27.276,21.5 27.5,21.724 27.5,22"
          fill="#00000"
          className={styles.defaultColor}
        />
        <path
          d="M38.7678,6.7678 C36.8148,8.7208 34.6968,8.4818 33.4648,8.5358 C33.5178,7.3038 33.2798,5.1848 35.2318,3.2318 C37.1848,1.2798 39.3038,1.5178 40.5358,1.4648 C40.4818,2.6968 40.7208,4.8148 38.7678,6.7678"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
      </g>
    </Icon>
  )
}
